/**
 * This is the Entry Point for the whole App.
 * We agreed that if a Dev-level configuration is needed, should be here.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';
import * as serviceWorker from './serviceWorkerRegistrar';
import i18n from './locales/i18n';
import config from './config';
// https://getbootstrap.com/docs/4.1/getting-started/contents/#css-files
import 'bootstrap/dist/css/bootstrap-reboot.min.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import './index.css';

/** The App per se */
import App from './components/App';

if (module.hot) {
  // if DEV ENV, then render
  ReactDOM.render(<App />, document.getElementById('root'));
  serviceWorker.unregister();
} else {
  i18n.options.debug = false;
  const instance = createInstance({
    urlBase: 'https://s.medel.com/',
    siteId: config.matomoSiteId,
    heartBeat: {
      active: false,
    },
    linkTracking: false,
    configurations: {
      disableCookies: false,
      setSecureCookie: false,
    },
  });
  ReactDOM.hydrate(
    <MatomoProvider value={instance}>
      <App />
    </MatomoProvider>,
    document.getElementById('root'),
  );
  serviceWorker.register();
}
